<template>
  <div class="huangshan-home">
    <Header
      :tabList="tabList"
      :isEnglish="isEnglish" 
      :Selectlanguage="Selectlanguage"
      :value="selectValue"
      @change="onTabChange"
      @lang="onLanChane"
    />
    <router-view></router-view>
    <Footer
      :info="info"
    />
    <div class="contactUs">
      <div 
        class="qrcode" 
        v-on:mouseover="changeActive('on')" 
        v-on:mouseout="changeActive('off')">
        <i></i>
        <span class="qrcodeBox" :class="{'qrcodeBoxon':isqrcodeBoxon}">
          <img src="../../assets/images/huangshan/qrcode.jpg" alt="">
          <em>黄山旅游</em>
          <i class="arrToRight">
          </i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Header from "../huangshan/components/header";
import Footer from "../huangshan/components/footer";
import api from "@/api/api";
import { apiGet } from "@/fetch/api";
export default {
  components: {
    Header,
    Footer
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      navData: {},
      mid:730,
      page:1,
      isqrcodeBoxon:false,
      tabList: [
        {
          label: '首页',
          value: 'home',
          routeName: 'huangShanHomePage',
          path: '/home',
        },
        {
          label: '景区',
          value: 'jingqu',
          routeName: 'huangshanJingqu',
          path: '/list/ticket',
        },
        {
          label: '酒店',
          value: 'jiudian',
          routeName: 'huangshanJiudian',
          path: '/list/hotel',
        },
        {
          label: '餐饮',
          value: 'food',
          routeName: 'huangshanFood',
          path: '/list/eatery',
        },
        {
          label: '商品',
          value: 'shop',
          routeName: 'huangshanShop',
          path: '/list/shop',
        },
        {
          label: '套票',
          value: 'allTickets',
          routeName: 'huangshanAllTickets',
          path: '/list/allTickets',
        },
        {
          label: '跟团游',
          value: 'gentuan',
          routeName: 'huangshanGentuan',
          path: '/list/route',
        },
        {
          label: '攻略',
          value: 'strategy',
          routeName: 'huangshanStrategy',
          path: '/newslist',
        },
        {
          label: '关于我们',
          value: 'aboutWe',
          routeName: 'huangshanAboutWe',
          path: '/detail/news',
        },
      ],
      selectValue: 'home',
      ticketList: [],
      shopList: [],
      isEnglish: false,
      Selectlanguage: 'chinese',
      info: {},
    };
  },
   computed: {
    ...mapState("privateConfig", ["pageWidth"])
  },
  created () {
    this.initNav();
    this.getInfo();
    //this.onTabChange();
  },
  methods: {
    changeActive(val){
      if(val=="on"){
        this.isqrcodeBoxon=true;
      }else{
        this.isqrcodeBoxon=false;
      }
    },
    reload() {
      this.isRouterAlive = false;
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    // 菜单切换(更换 前端菜单写死)
    onTabChange(data) {
      this.selectValue = data.routeName;
      localStorage.setItem('selectValue', data.routeName);
      if (data.routeName === 'huangShanHomePage') { // 首页
        this.$router.push({
          path: '/home',
        });
      } else if(data.routeName === 'huangshanJingqu') { // 景区
        this.$router.push({
          path: '/list/ticket',
          query: {
            page:this.page,
            m_id:this.mid
          }
        });
      } else if(data.routeName === 'huangshanJiudian') { // 酒店
        this.$router.push({
          path: '/list/hotel',
          query: {
            page:this.page,
            m_id:this.mid
          }
        });
      } else if(data.routeName === 'huangshanGentuan') { // 自由行
        this.$router.push({
          path: '/list/route',
          query: {
            page:this.page,
            m_id:this.mid
          }
        });
      } else if(data.routeName === 'huangshanAllTickets') { // 套票
        this.$router.push({
          path: '/list/allTickets',
          query: {
            page:this.page,
            m_id:this.mid
          }
        });
      }else if(data.routeName === 'huangshanFood') { // 餐饮
        this.$router.push({
          path: '/list/eatery',
          query: {
            page:this.page,
            m_id:this.mid
          }
        });
      } else if(data.routeName === 'huangshanShop') { // 商品
        this.$router.push({
          path: '/list/shop',
          query: {
            page:this.page,
            m_id:this.mid
          }
        });
      } else if(data.routeName === 'huangshanStrategy') { // 攻略
        this.$router.push({
          path: '/newslist',
          query: {
            pid:1073,
            m_id:this.mid
          }
        });
      } else if(data.routeName === 'huangshanAboutWe') { // 关于我们
        this.$router.push({
          path: '/detail/news',
          query: {
            pid:2975,
            menuId:1074,
            m_id:this.mid
          }
        });
      }
    },
    onLanChane(type){
      if(type==='chinese'){
        this.isEnglish=false;
      }
      if(type==='English'){
        this.isEnglish=true;
      }
      this.Selectlanguage=type;
    },
    // 获取header、footer 信息
    getInfo() {
      const url = api.main.getMerchantInfo;
      const params = {
        merchantInfoId: this.$route.query.m_id
      }
      apiGet(url, params).then(res => {
        this.info = res.data;
      });
    },
    // 获取导航菜单
    initNav() {
      let customUrl = api.main.getUsePage;
      apiGet(customUrl, {
        pageType: "pcPage",
        useRange: "pcWebsite"
      }).then(res => {
        if (res.data && res.data.content) {
          try {
            this.navData = JSON.parse(res.data.content);
          } catch (error) {
            this.navData = {};
          }
        }
      });
    },
  }
}
</script>
<style scoped>
img{
  width: 100%;
  height: 100%;
}
.contactUs {
  position: fixed;
  top: 50%;
  margin-top: -150px;
  right: 10px;
  width: 65px;
  z-index: 999;
  
}
.qrcode{
    background-color: #006953;
    display: block;
    margin-bottom: 5px;
    position: relative;
    width: 65px;
    height: 59px;
    padding: 3px 0;
    cursor: pointer;
}
.qrcodeBox {
  display: none;
}
.qrcodeBoxon{
  display: block;
  position: absolute;
  right: 75px;
  top: -140px;
  width: 144px;
  padding: 12px;
  background-color: rgba(0,0,0,.85);
  border-radius: 10px;
}
.qrcode i {
    background: url(../../assets/images/huangshan/ewm.png) no-repeat;
    width: 34px;
    height: 34px;
    display: block;
    margin: 0 auto;
    margin-top: 8px;
}
.qrcodeBox em {
    display: block;
    margin-top: 8px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #fff;
}
.arrToRight {
    position: absolute;
    bottom: 20px;
    right: -34px;
    width: 0;
    height: 0;
    border-top: 11px solid transparent;
    border-left: 11px solid rgba(0,0,0,.85);
    border-bottom: 11px solid transparent;
}

.huangshan-home{
  width: 100%;
  overflow: hidden;
  background: #fff;
}

</style>


// WEBPACK FOOTER //
// src/pages/huangshan/index.vue